
/**
 * Given a string it will attempt to parse it to a float value and fix the significant digits to 3.
 *
 * @param {string} numStr
 * @returns {any}
 */
export const parseAndShortenFloat = (numStr, precision = 3) => {
  try {
    return numStr ? parseFloat(numStr).toFixed(precision) : null;
  } catch (e) {
    return null;
  }
};
